import React from 'react'

const Spin = () => {
  return (
    <div>Spin</div>
  )
}

export default Spin